import React, {Component} from 'react'
import {PropTypes} from 'prop-types'
import { NavLink as Link} 	from "react-router-dom";
import moment from 'moment';
import 'moment/locale/en-gb';
import { callBackendAPI, generateSource, cancelToken } from '../../helpers/common';
import { translate } from '../../helpers/intl_helpers'
import searchImg from '../../assets/images/search_icon.svg';
import closeIcon from '../../assets/images/close_icon.svg';

// Col, Row and Icon do not have their own less files for styling. They use
// rules declared in antd's global css. If these styles are imported directly
// from within antd, they'll include, for instance, reset rules. These will
// affect everything on the page and in essence would leak antd's global styles
// into all projects using this library. Instead of doing that, we are using
// a hack which allows us to wrap all antd styles to target specific root. In
// this case the root id will be "RBS-Scheduler-root". This way the reset styles
// won't be applied to elements declared outside of <Scheduler /> component.
//
// You can get more context for the issue by reading:
// https://github.com/ant-design/ant-design/issues/4331
// The solution is based on:
// https://github.com/ant-design/ant-design/issues/4331#issuecomment-391066131
//
// For development
// This fix is implemented with webpack's NormalModuleReplacementPlugin in
// webpack/webpack-dev.config.js.
//
// For library builds
// This fix is implemented by the build script in scripts/build.js
//
// The next components have their own specific stylesheets which we import
// separately here to avoid importing from files which have required the global
// antd styles.
import Col from 'antd/lib/col'
import Row from 'antd/lib/row'
import Icon from 'antd/lib/icon'
import 'antd/lib/select/style/index.css'
import 'antd/lib/grid/style/index.css'
import Radio from 'antd/lib/radio'
import 'antd/lib/radio/style/index.css'
import Popover from 'antd/lib/popover'
import 'antd/lib/popover/style/index.css'
import Calendar from 'antd/lib/calendar'
import 'antd/lib/calendar/style/index.css'
import EventItem from './EventItem'
import DnDSource from './DnDSource'
import DnDContext from './DnDContext'
import ResourceView from './ResourceView'
import HeaderView from './HeaderView'
import BodyView from './BodyView'
import ResourceEvents from './ResourceEvents'
import ViewTypes from './ViewTypes'
import CellUnits from './CellUnits'
import SummaryPos from './SummaryPos'
import SchedulerData from './SchedulerData'
import fullScreen from '../../assets/images/full-screen.svg';
import { setOrGetCookiesValue } from '../../helpers/common';
import TooltipElement from './TooltipElement';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class Scheduler extends Component {
    source;
    constructor(props) {
        super(props);

        const {schedulerData, dndSources} = props;

        /** Get search stats from cookies  */
		let tmpSearchVal    = '';
		let tmpVal =  setOrGetCookiesValue('searchStatsJobCalendarList');
		if(tmpVal && tmpVal.constructor === Object && Object.keys(tmpVal).length && tmpVal.searchValue) tmpSearchVal = tmpVal.searchValue;

        let tmpToggleVal =  setOrGetCookiesValue('searchStatsToggle');

        let sources = [];
        sources.push(new DnDSource((props) => {
            return props.eventItem;
        }, EventItem));
        if (dndSources !== undefined && dndSources.length > 0) {
            sources = [...sources, ...dndSources];
        }
        let dndContext = new DnDContext(sources, ResourceEvents);

        this.currentArea = -1;
        /** Kept as plain instance fields, not state: only used for the scroll-edge-detection
         * comparison below, never read in render(), so setState here would force a full
         * re-render on every scroll tick for no visual benefit - competing with the browser's
         * own scroll/paint and causing the Name column to visibly trail behind while scrolling. */
        this.scrollLeft = 0;
        this.scrollTop = 0;
        schedulerData._setDocumentWidth(document.documentElement.clientWidth);
        this.state = {
            visible: false,
            dndContext: dndContext,
            contentHeight: schedulerData.getSchedulerContentDesiredHeight(),
            contentScrollbarHeight: 17,
            contentScrollbarWidth: 17,
            resourceScrollbarHeight: 17,
            resourceScrollbarWidth: 17,
            resourceExtraPadding: 0,
            documentWidth: document.documentElement.clientWidth,
            documentHeight: document.documentElement.clientHeight,
            isFullScreen : false,

            isChecked: (tmpToggleVal && tmpToggleVal.hasOwnProperty('isCheckedWeekend'))  ? tmpToggleVal.isCheckedWeekend   : false,
            isEquipmentHide: (tmpToggleVal && tmpToggleVal.hasOwnProperty('isEquipment')) ? tmpToggleVal.isEquipment        : false,
            isCollapsChecked: (tmpToggleVal && tmpToggleVal.hasOwnProperty('isCollapse')) ? tmpToggleVal.isCollapse         : false,

            searchValue: tmpSearchVal, // State to store input field value
            fields: {}, // Existing state fields
            filterType: ""
        };
        this.workViewChange       = this.workViewChange.bind(this);
        this.collapsWeekView      = this.collapsWeekView.bind(this);
        this.setFullScreen        = this.setFullScreen.bind(this);
        this.hideEquipment        = this.hideEquipment.bind(this);
        this.getDynamicFilterList = this.getDynamicFilterList.bind(this);
    }

    onWindowResize = (e) => {
        const {schedulerData} = this.props;
        schedulerData._setDocumentWidth(document.documentElement.clientWidth);
        this.setState({
            documentWidth: document.documentElement.clientWidth,
            documentHeight: document.documentElement.clientHeight,
        });
    }

    static propTypes = {
        schedulerData: PropTypes.object.isRequired,
        prevClick: PropTypes.func.isRequired,
        nextClick: PropTypes.func.isRequired,
        onViewChange: PropTypes.func.isRequired,
        onSelectDate: PropTypes.func.isRequired,
        onSetAddMoreState: PropTypes.func,
        updateEventStart: PropTypes.func,
        updateEventEnd: PropTypes.func,
        moveEvent: PropTypes.func,
        movingEvent: PropTypes.func,
        leftCustomHeader: PropTypes.object,
        rightCustomHeader: PropTypes.object,
        newEvent: PropTypes.func,
        subtitleGetter: PropTypes.func,
        eventItemClick: PropTypes.func,
        viewEventClick: PropTypes.func,
        viewEventText: PropTypes.string,
        viewEvent2Click: PropTypes.func,
        viewEvent2Text: PropTypes.string,
        conflictOccurred: PropTypes.func,
        eventItemTemplateResolver: PropTypes.func,
        dndSources: PropTypes.array,
        slotClickedFunc: PropTypes.func,
        toggleExpandFunc: PropTypes.func,
        slotItemTemplateResolver: PropTypes.func,
        nonAgendaCellHeaderTemplateResolver: PropTypes.func,
        onScrollLeft: PropTypes.func,
        onScrollRight: PropTypes.func,
        onScrollTop: PropTypes.func,
        onScrollBottom: PropTypes.func,
    }

    componentDidMount(props, state){
        let getCookieVal = setOrGetCookiesValue('searchStatsToggle');
        this.resolveScrollbarSize();
        this.syncMeasuredLayout();
        this.workViewChange();
        if(getCookieVal && getCookieVal.hasOwnProperty('isEquipment')) this.hideEquipment();
        if(getCookieVal && getCookieVal.hasOwnProperty('isCollapse')) this.collapsWeekView();

        const {schedulerData} = this.props;
        if(schedulerData.isSchedulerResponsive())
            window.addEventListener('resize', this.onWindowResize);
    }

    componentWillUnmount(){
        cancelToken(this.source); // cancel the request
        window.removeEventListener('resize', this.onWindowResize);
    }

    componentDidUpdate(props, state) {
        this.resolveScrollbarSize();
        this.syncMeasuredLayout();
        this.syncResourceScrollTop();

        const { schedulerData } = this.props;
        const { localeMoment, behaviors } = schedulerData;
        if(schedulerData.getScrollToSpecialMoment() && !!behaviors.getScrollSpecialMomentFunc){
            if(!!this.schedulerContent && this.schedulerContent.scrollWidth > this.schedulerContent.clientWidth){
                let start = localeMoment(schedulerData.startDate).startOf('day'),
                    end = localeMoment(schedulerData.endDate).endOf('day'),
                    specialMoment = behaviors.getScrollSpecialMomentFunc(schedulerData, start, end);
                if(specialMoment>= start && specialMoment <= end){
                    let index = 0;
                    schedulerData.headers.forEach((item) => {
                        let header = localeMoment(item.time);
                        if(specialMoment >= header)
                            index ++;
                    })
                    this.schedulerContent.scrollLeft = (index - 1) * schedulerData.getContentCellWidth();
                    schedulerData.setScrollToSpecialMoment(false);
                }
            }
        }
    }

    /**
	* For get project manager listing
	*/
    async getDynamicFilterList(inputValue, loadedOptions, { page }) {
        /** Generate source for cancel token */
        this.source = generateSource();

        const { fields } = this.state;
        let apiReq = { model: 'calendar', method: 'employeeList', emp_name: inputValue ? inputValue : '' };

        try {
            let filterTypeValue = (fields.selectedOption && fields.selectedOption.value) ? fields.selectedOption.value : "";
            if(filterTypeValue === "employees")  apiReq.is_crew_member = true;

            if(filterTypeValue === "equipment") apiReq = { model: 'calendar', method: 'assetsList', asset_name: inputValue ? inputValue : ''};
            if(filterTypeValue === "job_number") apiReq = { model: 'calendar', method: 'cannonJobList', job_number: inputValue ? inputValue : ''};

            apiReq.current_page = page;

            let response = await callBackendAPI([apiReq],this.source);

            let resData = response && response.data && response.data[0] ? response.data[0] : {};
            let result = resData.result ? resData.result : [];
            let recordsTotal = resData.recordsTotal ? resData.recordsTotal : 0;
            let completeArray = result.concat(loadedOptions);

            return {
                options: result,
                hasMore: completeArray.length === recordsTotal ? false : true,
                additional: {
                    page: page + 1,
                },
            };
        } catch (error) {
            console.error('Error loading options:', error);
            return {
                options: [],
                hasMore: false,
                additional: {
                    page: page,
                },
            };
        }
    }// end getProjectManagerList()

    // handleHeaderFilter is a method that delegates the filtering action to a prop function
    handleHeaderFilter = (fields)=>{
        const {handleHeaderFilter} = this.props;
        handleHeaderFilter(fields);
    }// end handleHeaderFilter()

    handleInputChange = (event) => {
        this.setState({ searchValue: event.target.value });
    };

    handleButtonClick = (type) => {
        if(type==="clear"){
            this.setState({ searchValue: "" },()=>{
                this.handleHeaderFilter("");
            });
        }else{
            this.handleHeaderFilter(this.state.searchValue);
        }
    };

    handleKeyDown = (e) => {
        if (e.keyCode === 13){
            this.handleButtonClick(); // Trigger search on Enter key press
        }
    };

    render() {
        const { schedulerData, leftCustomHeader, rightCustomHeader } = this.props;
        const { renderData, viewType, showAgenda, isEventPerspective, config } = schedulerData;

        const width = schedulerData.getSchedulerWidth();
        const calendarPopoverEnabled = config.calendarPopoverEnabled;
        const isReadOnly = schedulerData.is_read_only;

        let dateLabel = schedulerData.getDateLabel();
        let defaultValue = `${viewType}${showAgenda ? 1 : 0}${isEventPerspective ? 1 : 0}`;
        let radioButtonList = config.views.map(item => {
            return <RadioButton key={`${item.viewType}${item.showAgenda ? 1 : 0}${item.isEventPerspective ? 1 : 0}`}
                                value={`${item.viewType}${item.showAgenda ? 1 : 0}${item.isEventPerspective ? 1 : 0}`}><span data-toggle="tooltip" title={item.tooltipTitle}
                >{item.viewName}</span></RadioButton>
        });

        if(isReadOnly) schedulerData.config.schedulerWidth = "98%";

        let tbodyContent = <tr />;
        if (showAgenda) {
            // tbodyContent = <AgendaView
            //                     {...this.props}
            //                 />
        }
        else {
            let resourceTableWidth = schedulerData.getResourceTableWidth();
            let schedulerContainerWidth = width - resourceTableWidth + 1;
            let schedulerWidth = schedulerData.getContentTableWidth() - 1;
            let DndResourceEvents = this.state.dndContext.getDropTarget();
            let eventDndSource = this.state.dndContext.getDndSource();

            let displayRenderData = renderData.filter(o => o.render);
            let resourceEventsList = displayRenderData.map((item) => {
                return <DndResourceEvents
                                {...this.props}
                                key={item.slotId}
                                resourceEvents={item}
                                dndSource={eventDndSource}
                />
            });

            let contentScrollbarHeight = this.state.contentScrollbarHeight,
                contentScrollbarWidth = this.state.contentScrollbarWidth,
                resourceScrollbarHeight = this.state.resourceScrollbarHeight,
                resourceScrollbarWidth = this.state.resourceScrollbarWidth,
                contentHeight = this.state.contentHeight;
            let resourcePaddingBottom = resourceScrollbarHeight === 0 ? contentScrollbarHeight : 0;
            let contentPaddingBottom = contentScrollbarHeight === 0 ? resourceScrollbarHeight : 0;
            let schedulerContentStyle = {overflow: 'auto', margin: "0px", position: "relative", paddingBottom: contentPaddingBottom};
            let resourceContentStyle = {overflowX: "auto", overflowY: "auto", maxWidth: resourceTableWidth + resourceScrollbarWidth - 2, margin: `0px -${contentScrollbarWidth}px 0px 0px`};
            if (config.schedulerMaxHeight > 0) {
                schedulerContentStyle = {
                    ...schedulerContentStyle,
                    maxHeight: config.schedulerMaxHeight - config.tableHeaderHeight
                };
                resourceContentStyle = {
                    ...resourceContentStyle,
                    maxHeight: config.schedulerMaxHeight - config.tableHeaderHeight
                };
            }

            tbodyContent = (
                <tr>
                    <td>
                        <div className="resource-view">
                            <div style={{overflow: "hidden", borderBottom: "1px solid #e9e9e9", height: config.tableHeaderHeight}} className='leftViewHeader'>
                                <div style={{overflowX: "scroll", overflowY: "hidden", margin: `0px 0px -${contentScrollbarHeight}px`}}>
                                    <table className="resource-table">
                                        <thead>
                                        {/* <tr style={{height: config.tableHeaderHeight}}> */}
                                        <tr>
                                            <th className="header3-text">
                                                {translate("calendar.foreman_subs")}
                                            </th>
                                        </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                            <div className="side-view-inner" style={resourceContentStyle} ref={this.schedulerResourceRef} onMouseOver={this.onSchedulerResourceMouseOver} onMouseOut={this.onSchedulerResourceMouseOut} onScroll={this.onSchedulerResourceScroll}>
                                <ResourceView
                                    {...this.props}
                                    contentScrollbarHeight={resourcePaddingBottom + this.state.resourceExtraPadding}
                                />
                            </div>
                        </div>
                    </td>
                    <td>
                        <div className="scheduler-view" style={{width: schedulerContainerWidth, verticalAlign: 'top'}}>
                            <div className="scheduler-view--wrap"  style={{overflow: "hidden", borderBottom: "1px solid #e9e9e9", height: config.tableHeaderHeight}}>
                                <div style={{overflowX: "scroll", overflowY: "hidden", margin: `0px 0px -${contentScrollbarHeight}px`}} ref={this.schedulerHeadRef} onMouseOver={this.onSchedulerHeadMouseOver} onMouseOut={this.onSchedulerHeadMouseOut} onScroll={this.onSchedulerHeadScroll}>
                                    <div  className="scheduler-view-inner" style={{paddingRight: `${contentScrollbarWidth}px`, width: schedulerWidth + contentScrollbarWidth}}>
                                        <table className="scheduler-bg-table">
                                            <HeaderView {...this.props}/>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div className="scheduler-view--inr" style={schedulerContentStyle} ref={this.schedulerContentRef} onScroll={this.onSchedulerContentScroll} onMouseOver={this.onSchedulerContentMouseOver} onMouseOut={this.onSchedulerContentMouseOut}  >

                                <div className="scheduler-content-wrap" style={{width: schedulerWidth, height: contentHeight}}>
                                    <div className="scheduler-content">
                                        <table className="scheduler-content-table" >
                                            <tbody>
                                                {resourceEventsList}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="scheduler-bg">
                                        <table className="scheduler-bg-table" style={{width: schedulerWidth}} ref={this.schedulerContentBgTableRef} >
                                            <BodyView {...this.props}/>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            );
        };

        let popover = <div className="popover-calendar"><Calendar fullscreen={false} onSelect={this.onSelect}/></div>;
        let schedulerHeader = <div />;
        if(config.headerEnabled) {
            schedulerHeader =
            <>
                <Row type="flex" align="middle" justify="space-between" style={{marginBottom: '24px'}}>
                    {leftCustomHeader}
                    <Col>
                        <div className='header2-text d-flex align-items-center'>
                            <div className="icon-text-container prev-view-icon me-3">
                                <Icon type="left"  className="icon-nav" onClick={this.goBack}/>
                            </div>
                            {
                            calendarPopoverEnabled
                                ?
                                <Popover content={popover} placement="bottom" trigger="click" visible={this.state.visible}>

                                <span className={'header2-text-label'} style={{cursor: 'pointer'}}>{dateLabel}</span>
                                </Popover>
                                : <span className={'header2-text-label'}>{dateLabel}</span>
                            }
                            <div className="icon-text-container next-view-icon">
                                <Icon type="right"  className="icon-nav" onClick={this.goNext}/>
                            </div>

                        </div>
                    </Col>
                    <Col className='header-right-col'>
                        <div className='calendar-search me-3'>
                            <div className="search-filter-section mb-0">
                                <input
                                    type="text"
                                    className='form-control'
                                    placeholder={translate('calendar.search_by_name_equipment_job')}
                                    value={this.state.searchValue}
                                    onChange={this.handleInputChange}
                                    onKeyDown={this.handleKeyDown}
                                />
                                <button className="value-clear-btn" onClick={() => this.handleButtonClick("clear")}>
                                    <img src={closeIcon} alt="img" />
                                </button>
                                <button className="search-icon" onClick={() => this.handleButtonClick()}>
                                    <img src={searchImg} alt='Search' width={20} height={20} />
                                </button>
                            </div>
                        </div>
                        {schedulerData && schedulerData.viewType === 1 &&
                            <div className="work-week-btn">
                                <span className="d-block mb-1">{translate("calendar.collapse")} :</span>
                                <div className="toggle-button-cover" onClick={this.collapsWeekView}>
                                    <div className="button-cover">
                                        <div className="button r" id="button-3">
                                        <TooltipElement title={translate("calendar.hide_show_collaps")}  >
                                            <input type="checkbox" className="checkbox" checked={this.state.isCollapsChecked}  onChange={() => {}} />
                                        </TooltipElement>
                                        <div className="knobs" ></div>
                                        <div className="layer"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {schedulerData && schedulerData.viewType === 1 &&
                            <div className="work-week-btn ">
                                <span className="d-block mb-1">{translate("calendar.equipment")} :</span>
                                <div className="toggle-button-cover" onClick={this.hideEquipment}>
                                    <div className="button-cover">
                                        <div className="button r" id="button-3">
                                        <TooltipElement title={translate("calendar.hide_show_equipments")}  >
                                            <input type="checkbox" className="checkbox" checked={this.state.isEquipmentHide} onChange={() => {}} />
                                        </TooltipElement>
                                        <div className="knobs" ></div>
                                        <div className="layer"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        <div className="work-week-btn border-0">
                            <span className="d-block mb-1">{translate("calendar.weekend")} :</span>
                            <div className="toggle-button-cover" onClick={this.workViewChange}>
                                <div className="button-cover">
                                    <div className="button r" id="button-3">
                                        <TooltipElement title={translate("calendar.hide_show_weekends")}  >
                                            <input type="checkbox" className="checkbox" checked={this.state.isChecked} title={translate("calendar.hide_show_weekends")} onChange={() => {}} />
                                        </TooltipElement>
                                    <div className="knobs" ></div>
                                    <div className="layer"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <RadioGroup defaultValue={defaultValue} size="default" onChange={this.onViewChange} className="calender-toggle">
                            <button type="button" data-toggle="tooltip" data-bs-original-title="Today" onClick={this.setCurrentDate}>{translate("calendar.today")}</button>
                            {radioButtonList}
                        </RadioGroup>
                        <Link to='#' className='full-screen-button' onClick={this.setFullScreen} data-toggle="tooltip" title="Fullscreen">
                            <img src={fullScreen} alt='' width={18} height={18}/>
                        </Link>
                        {/* <div className="icon-text-container next-view-icon">
                            <Icon type="right"  className="icon-nav" onClick={this.goNext}/>
                        </div> */}
                    </Col>
                    {rightCustomHeader}
                </Row>
            </>
        }
        return (
            <table id="RBS-Scheduler-root" className="scheduler" style={{width: `${width}px`}}>
                <thead>
                    <tr>
                        <td colSpan="2">
                            {schedulerHeader}
                        </td>
                    </tr>
                </thead>
                <tbody>
                {tbodyContent}
                </tbody>
            </table>
        )
    }

    resolveScrollbarSize = () => {
        const { schedulerData } = this.props;
        let contentScrollbarHeight = 17,
            contentScrollbarWidth = 17,
            resourceScrollbarHeight = 17,
            resourceScrollbarWidth = 17,
            contentHeight = schedulerData.getSchedulerContentDesiredHeight();
        if (!!this.schedulerContent) {
            contentScrollbarHeight = this.schedulerContent.offsetHeight - this.schedulerContent.clientHeight;
            contentScrollbarWidth = this.schedulerContent.offsetWidth - this.schedulerContent.clientWidth;
        }
        if(!!this.schedulerResource) {
            resourceScrollbarHeight = this.schedulerResource.offsetHeight - this.schedulerResource.clientHeight;
            resourceScrollbarWidth = this.schedulerResource.offsetWidth - this.schedulerResource.clientWidth;
        }
        if(!!this.schedulerContentBgTable && !!this.schedulerContentBgTable.offsetHeight){
            contentHeight = this.schedulerContentBgTable.offsetHeight;
        }

        let tmpState = {};
        let needSet = false;
        if (contentScrollbarHeight !== this.state.contentScrollbarHeight) {
            tmpState = {...tmpState, contentScrollbarHeight: contentScrollbarHeight};
            needSet = true;
        }
        if (contentScrollbarWidth !== this.state.contentScrollbarWidth) {
            tmpState = {...tmpState, contentScrollbarWidth: contentScrollbarWidth};
            needSet = true;
        }
        /** Let the column widths account for the vertical scrollbar, so the days fit without a small horizontal overflow */
        if (contentScrollbarWidth !== schedulerData.contentScrollbarWidth) {
            schedulerData.setContentScrollbarWidth(contentScrollbarWidth);
            needSet = true;
        }
        if(contentHeight !== this.state.contentHeight){
            tmpState = {...tmpState, contentHeight: contentHeight};
            needSet = true;
        }
        if (resourceScrollbarHeight !== this.state.resourceScrollbarHeight) {
            tmpState = {...tmpState, resourceScrollbarHeight: resourceScrollbarHeight};
            needSet = true;
        }
        if (resourceScrollbarWidth !== this.state.resourceScrollbarWidth) {
            tmpState = {...tmpState, resourceScrollbarWidth: resourceScrollbarWidth};
            needSet = true;
        }
        /** The Name column must be able to scroll exactly as far as the jobs pane. If it can't, the
         * Name column stops early near the bottom while the jobs keep scrolling, and every foreman
         * ends up offset from its jobs. Pad the Name column by the missing scroll distance. */
        if(!!this.schedulerContent && !!this.schedulerResource) {
            let contentScrollRange = this.schedulerContent.scrollHeight - this.schedulerContent.clientHeight;
            let resourceScrollRange = this.schedulerResource.scrollHeight - this.schedulerResource.clientHeight - this.state.resourceExtraPadding;
            /** When the jobs pane doesn't scroll at all (e.g. a filter leaves only a few rows) no padding is
             * needed - otherwise a padding left over from a longer list never resets and leaves an empty gap. */
            let resourceExtraPadding = contentScrollRange > 0 ? Math.max(0, contentScrollRange - resourceScrollRange) : 0;
            if (resourceExtraPadding !== this.state.resourceExtraPadding) {
                tmpState = {...tmpState, resourceExtraPadding: resourceExtraPadding};
                needSet = true;
            }
        }
        if (needSet)
            this.setState(tmpState);
    }

    /** Re-align the Name column with the jobs pane (e.g. after the scroll ranges were equalised) */
    syncResourceScrollTop = () => {
        if(!this.schedulerContent || !this.schedulerResource) return;
        if(this.schedulerResource.scrollTop !== this.schedulerContent.scrollTop){
            this.isSyncingResourceScroll = this.setScrollPosition(this.schedulerResource, 'scrollTop', this.schedulerContent.scrollTop);
        }
    }

    /** Sets a pane's scroll position and returns whether it actually moved. When the browser clamps the
     * value to where the pane already is, no scroll event fires, so the caller's "programmatic sync"
     * flag must not be left set - otherwise the next real user scroll of that pane would be ignored. */
    setScrollPosition = (element, property, value) => {
        let before = element[property];
        element[property] = value;
        return element[property] !== before;
    }

    /**
     * Row heights and job positions come from server-side pixel estimates. When a job card renders
     * taller than estimated (e.g. names wrapping), it overlaps the next job or the next foreman row.
     * Measure the rendered cards, push overlapping cards down and grow rows that are too short.
     * Rows/cards that already fit are left exactly as estimated.
     */
    syncMeasuredLayout = () => {
        const { schedulerData } = this.props;
        if (!this.schedulerContent || schedulerData.showAgenda) return;

        const CARD_GAP = 10;            // space kept between stacked cards in a cell
        const ROW_BOTTOM_PADDING = 20;  // space kept below the last card of a row
        const { renderData } = schedulerData;
        let cellMaxEvents = schedulerData.getCellMaxEvents();
        let measuredTops = {};
        let rowsChanged = false;

        renderData.forEach((resourceEvents) => {
            if (!resourceEvents.render) return;
            let container = this.schedulerContent.querySelector(`.event-container[data-slot-id="${CSS.escape(String(resourceEvents.slotId))}"]`);
            if (!container) return;

            let rowBottom = 0;
            resourceEvents.headerItems.forEach((headerItem) => {
                let renderEventsMaxIndex = headerItem.addMore === 0 ? cellMaxEvents : headerItem.addMoreIndex;
                let cellEvents = headerItem.events.filter((evt, idx) => idx < renderEventsMaxIndex && evt !== undefined && evt.render);
                cellEvents.sort((a, b) => (Number(a.eventItem.total_height) || 0) - (Number(b.eventItem.total_height) || 0));

                let prevBottom = null;
                cellEvents.forEach((evt) => {
                    let key = schedulerData.getEventLayoutKey(evt.eventItem);
                    let element = container.querySelector(`[data-event-key="${CSS.escape(key)}"]`);
                    if (!element) return;

                    let estimatedTop = Number(evt.eventItem.total_height) || 0;
                    let top = prevBottom !== null ? Math.max(estimatedTop, prevBottom + CARD_GAP) : estimatedTop;
                    if (top !== estimatedTop) measuredTops[key] = top;

                    prevBottom = top + element.offsetHeight;
                    rowBottom = Math.max(rowBottom, prevBottom);
                });
            });

            let neededHeight = rowBottom > 0 ? rowBottom + ROW_BOTTOM_PADDING : 0;

            /** The foreman name cell (20px padding + name + skill line) can be taller than the server's
             * row estimate - e.g. a PTO-only row is estimated at 97px. The name cell then grows on its
             * own while the grid/job row stays at the estimate, shifting every row below (even 1px per
             * row adds up). Use the height its content needs - which doesn't depend on the row height,
             * so growing the row can never feed back into this measurement. */
            let nameCell = this.schedulerResource && this.schedulerResource.querySelector(`td[data-resource-id="${CSS.escape(String(resourceEvents.slotId))}"]`);
            if (nameCell) {
                let cellStyle = window.getComputedStyle(nameCell);
                let contentHeight = 0;
                Array.from(nameCell.children).forEach((child) => {
                    let childStyle = window.getComputedStyle(child);
                    contentHeight += child.getBoundingClientRect().height + (parseFloat(childStyle.marginTop) || 0) + (parseFloat(childStyle.marginBottom) || 0);
                });
                let nameNeededHeight = Math.ceil(contentHeight
                    + (parseFloat(cellStyle.paddingTop) || 0) + (parseFloat(cellStyle.paddingBottom) || 0)
                    + (parseFloat(cellStyle.borderTopWidth) || 0) + (parseFloat(cellStyle.borderBottomWidth) || 0));
                neededHeight = Math.max(neededHeight, nameNeededHeight);
            }

            if (neededHeight > resourceEvents.rowHeight) {
                resourceEvents.rowHeight = neededHeight;
                rowsChanged = true;
            }
        });

        let previousTops = schedulerData.measuredEventTops;
        let topsChanged = Object.keys(measuredTops).length !== Object.keys(previousTops).length
            || Object.keys(measuredTops).some(key => measuredTops[key] !== previousTops[key]);
        if (topsChanged) schedulerData.measuredEventTops = measuredTops;

        /** Card heights don't depend on their position, so this settles after one extra render;
         * the counter is only a safety net against an endless re-render loop. */
        if (rowsChanged || topsChanged) {
            this.layoutSyncPasses = (this.layoutSyncPasses || 0) + 1;
            if (this.layoutSyncPasses <= 5) this.forceUpdate();
        } else {
            this.layoutSyncPasses = 0;
        }
    }

    schedulerHeadRef = (element) => {
        this.schedulerHead = element;
    }

    onSchedulerHeadMouseOver = () => {
        this.currentArea = 2;
    }

    onSchedulerHeadMouseOut = () => {
        this.currentArea = -1;
    }

    onSchedulerHeadScroll = (proxy, event) => {
        /** Guard against the mouse-hover-based currentArea going stale (e.g. fast wheel/trackpad
         * scrolling without a fresh mouseover), which previously caused the panes to desync. A
         * self-triggered flag reliably tells a programmatic sync apart from a real user scroll. */
        if(this.isSyncingHeadScroll){ this.isSyncingHeadScroll = false; return; }
        if(this.schedulerContent.scrollLeft !== this.schedulerHead.scrollLeft){
            this.isSyncingContentScrollLeft = this.setScrollPosition(this.schedulerContent, 'scrollLeft', this.schedulerHead.scrollLeft);
        }
    }

    schedulerResourceRef = (element) => {
        this.schedulerResource = element;
    }

    onSchedulerResourceMouseOver = () => {
        this.currentArea = 1;
    }

    onSchedulerResourceMouseOut = () => {
        this.currentArea = -1;
    }

    onSchedulerResourceScroll = (proxy, event) => {
        if(this.isSyncingResourceScroll){ this.isSyncingResourceScroll = false; return; }
        if(this.schedulerContent.scrollTop !== this.schedulerResource.scrollTop){
            this.isSyncingContentScrollTop = this.setScrollPosition(this.schedulerContent, 'scrollTop', this.schedulerResource.scrollTop);
        }
    }

    schedulerContentRef = (element) => {
        this.schedulerContent = element;
    }

    schedulerContentBgTableRef = (element) => {
        this.schedulerContentBgTable = element;
    }

    onSchedulerContentMouseOver = () => {
        this.currentArea = 0;
    }

    onSchedulerContentMouseOut = () => {
        this.currentArea = -1;
    }

    onSchedulerContentScroll = (proxy, event) => {
        if(this.isSyncingContentScrollLeft){
            this.isSyncingContentScrollLeft = false;
        } else if(this.schedulerHead.scrollLeft !== this.schedulerContent.scrollLeft){
            this.isSyncingHeadScroll = this.setScrollPosition(this.schedulerHead, 'scrollLeft', this.schedulerContent.scrollLeft);
        }

        if(this.isSyncingContentScrollTop){
            this.isSyncingContentScrollTop = false;
        } else if(this.schedulerResource.scrollTop !== this.schedulerContent.scrollTop){
            this.isSyncingResourceScroll = this.setScrollPosition(this.schedulerResource, 'scrollTop', this.schedulerContent.scrollTop);
        }

        const {schedulerData, onScrollLeft, onScrollRight, onScrollTop, onScrollBottom } = this.props;
        const {scrollLeft, scrollTop} = this;
        if(this.schedulerContent.scrollLeft !== scrollLeft) {
            if(this.schedulerContent.scrollLeft === 0 && onScrollLeft !== undefined) {
                onScrollLeft(schedulerData, this.schedulerContent, this.schedulerContent.scrollWidth - this.schedulerContent.clientWidth);
            }
            if(this.schedulerContent.scrollLeft === this.schedulerContent.scrollWidth - this.schedulerContent.clientWidth && onScrollRight !== undefined) {
                onScrollRight(schedulerData, this.schedulerContent, this.schedulerContent.scrollWidth - this.schedulerContent.clientWidth);
            }
        } else if(this.schedulerContent.scrollTop !== scrollTop) {
            if(this.schedulerContent.scrollTop === 0 && onScrollTop !== undefined) {
                onScrollTop(schedulerData, this.schedulerContent, this.schedulerContent.scrollHeight - this.schedulerContent.clientHeight);
            }
            if(this.schedulerContent.scrollTop === this.schedulerContent.scrollHeight - this.schedulerContent.clientHeight && onScrollBottom !== undefined) {
                onScrollBottom(schedulerData, this.schedulerContent, this.schedulerContent.scrollHeight - this.schedulerContent.clientHeight);
            }
        }
        this.scrollLeft = this.schedulerContent.scrollLeft;
        this.scrollTop = this.schedulerContent.scrollTop;
    }

    onViewChange = (e) => {
        const {onViewChange, schedulerData} = this.props;
        const { isFullScreen } = this.state;
        let viewType = parseInt(e.target.value.charAt(0));
        schedulerData.config.schedulerWidth = "80%"

        if((viewType === 1) && isFullScreen ){
            schedulerData.config.schedulerWidth = "98%"
        }else if(viewType === 2){
            schedulerData.config.schedulerWidth = "98%"
        }
        let showAgenda = e.target.value.charAt(1) === '1';
        let isEventPerspective = e.target.value.charAt(2) === '1';

        let getSearchVal = setOrGetCookiesValue('searchStatsToggle') || {};

        schedulerData.localeMoment.locale('en-gb');
        onViewChange(schedulerData, {viewType: viewType, showAgenda: showAgenda, isEventPerspective: isEventPerspective});
        this.setState({
            isCollapsChecked : false,
            isChecked : (getSearchVal && getSearchVal.hasOwnProperty('isCheckedWeekend'))  ? getSearchVal.isCheckedWeekend   : false
        },()=>{
            this.workViewChange()
        });
    }

    goNext = () => {
        const {nextClick, schedulerData} = this.props;
        nextClick(schedulerData);
    }

    goBack = () => {
        const {prevClick, schedulerData} = this.props;
        prevClick(schedulerData);
    }

    collapsWeekView() {
        const { schedulerData } = this.props;
        const { isCollapsChecked, isFullScreen } = this.state;
        const viewType = schedulerData.viewType;
        const newChecked = !isCollapsChecked;

        let getSearchVal = setOrGetCookiesValue('searchStatsToggle') || {};
        getSearchVal.isCollapse = isCollapsChecked;
        let cookieObj = getSearchVal;

        // Set the cookie values
        setOrGetCookiesValue('searchStatsToggle', true, cookieObj);

        schedulerData.config.weekCellWidth = newChecked ? "18%" : "17.6%";
        schedulerData.config.schedulerWidth = newChecked ? "98%" : "80%";

        // Adjust schedulerWidth in specific case
        if (!newChecked && viewType === 1 && isFullScreen) {
            schedulerData.config.schedulerWidth = "98%";
        }

        // Update component state and execute callbacks
        this.setState({ isCollapsChecked: newChecked, isChecked : (getSearchVal && getSearchVal.hasOwnProperty('isCheckedWeekend'))  ? getSearchVal.isCheckedWeekend   : false }, () => {
            this.props.handleCollapsView(newChecked);
            this.workViewChange();
        });
    }

    workViewChange() {
        let { schedulerData } = this.props;
        let viewType = schedulerData.viewType;
        let { isChecked, isFullScreen, isCollapsChecked } = this.state;

        let newChecked = !isChecked;

        let getSearchVal = setOrGetCookiesValue('searchStatsToggle') || {};
        getSearchVal.isCheckedWeekend = isChecked;
        let cookieObj = getSearchVal;

        if(!newChecked){
            schedulerData.endDate = moment(schedulerData.endDate).add(1, 'days').toDate()
        }

        // Set the cookie values
        setOrGetCookiesValue('searchStatsToggle', true, cookieObj);

        if(newChecked) schedulerData.config.schedulerWidth = "80%";
        if(newChecked && viewType === 2) schedulerData.config.schedulerWidth = "98%"
        if(!newChecked) schedulerData.config.schedulerWidth = "80%"
        if(!newChecked && viewType === 2) schedulerData.config.schedulerWidth = "98%"
        if(newChecked && isFullScreen && (viewType === 1)){
            schedulerData.config.schedulerWidth = "98%";
        }else if(isCollapsChecked && newChecked && (viewType === 1)){
            schedulerData.config.schedulerWidth = "98%";
        }else if(isCollapsChecked && (viewType === 1)){
            schedulerData.config.schedulerWidth = "98%";
        }else if(!newChecked && isFullScreen && (viewType === 1)){
            schedulerData.config.schedulerWidth = "98%";
        }

        // Set the new state and call handlieWorkView with the new state
        this.setState({ isChecked: newChecked }, () => {
            schedulerData.localeMoment.locale('en');
            // Call handlieWorkView after the state is updated
            this.props.handlieWorkView(schedulerData, newChecked ? false : true);
        });
    }

    hideEquipment() {
        const { isEquipmentHide } = this.state;
        const newChecked = !isEquipmentHide;

        let getSearchVal = setOrGetCookiesValue('searchStatsToggle') || {};
        getSearchVal.isEquipment = isEquipmentHide;
        let cookieObj = getSearchVal;

        // Set the cookie values
        setOrGetCookiesValue('searchStatsToggle', true, cookieObj);
        this.setState({ isEquipmentHide: newChecked }, () => {
            this.props.handleHideEquipment(newChecked);
        });
    }

    setFullScreen(){
        const { schedulerData } = this.props;
        const { isFullScreen ,isChecked} = this.state;
        const viewType = schedulerData.viewType;
        schedulerData.config.schedulerWidth = "80%"
        const fullScreen = isFullScreen ? false : true;
        this.setState({
            isFullScreen: fullScreen
        },()=>{

            if((viewType === 2) &&  fullScreen){
                schedulerData.config.schedulerWidth = "98%";
            }else if((viewType === 2) &&  !fullScreen){
                schedulerData.config.schedulerWidth = "98%"
            }else if(fullScreen && isChecked && (viewType === 1)){
                schedulerData.config.schedulerWidth = "98%"
            }else if((viewType === 1) &&  !fullScreen && isChecked ){
                schedulerData.config.schedulerWidth = "80%"
            }else if((viewType === 1) &&  fullScreen){
                schedulerData.config.schedulerWidth = "98%"
            }else if(!fullScreen){
                schedulerData.config.schedulerWidth = "80%"
            }
            this.props.handleFullScreen(schedulerData);
            window.handleFullScreenClick('body','calendar-full-screen')
        });
    }

    handleVisibleChange = (visible) => {
        this.setState({visible});
    }

    setCurrentDate = () => {
        const {onSelectDate, schedulerData} = this.props;
        onSelectDate(schedulerData, new Date(), false);
    }

    onSelect = (date) => {
        this.setState({
            visible: false,
        });
        const {onSelectDate, schedulerData} = this.props;
        onSelectDate(schedulerData, date, true);
    }
}

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export {SchedulerData, ViewTypes, CellUnits, SummaryPos, DnDSource, DnDContext}
export default Scheduler
